import { formatNumber } from "../utils/formatters";

interface MobileBottomNavProps {
  cartItemsCount: number;
  compareItemsCount: number;
  onCartClick: () => void;
  onCompareClick: () => void;
  onHomeClick: () => void;
  onProductsClick: () => void;
  onSearchClick: () => void;
  onStoresClick: () => void;
}

interface IconProps {
  className?: string;
}

function HomeIcon({ className = "" }: IconProps) {
  return (
    <svg aria-hidden="true" className={className} fill="none" viewBox="0 0 24 24">
      <path d="M4 11.5 12 4l8 7.5" />
      <path d="M6.5 10.5V20h11v-9.5" />
      <path d="M10 20v-5h4v5" />
    </svg>
  );
}

function SearchIcon({ className = "" }: IconProps) {
  return (
    <svg aria-hidden="true" className={className} fill="none" viewBox="0 0 24 24">
      <circle cx="11" cy="11" r="6.5" />
      <path d="M16 16l4.2 4.2" />
    </svg>
  );
}

function StoreIcon({ className = "" }: IconProps) {
  return (
    <svg aria-hidden="true" className={className} fill="none" viewBox="0 0 24 24">
      <path d="M5 10h14l-1-5H6l-1 5Z" />
      <path d="M6.5 10v9h11v-9" />
      <path d="M9 19v-5h6v5" />
    </svg>
  );
}

function ProductsIcon({ className = "" }: IconProps) {
  return (
    <svg aria-hidden="true" className={className} fill="none" viewBox="0 0 24 24">
      <rect x="5" y="5" width="6" height="6" rx="1.5" />
      <rect x="13" y="5" width="6" height="6" rx="1.5" />
      <rect x="5" y="13" width="6" height="6" rx="1.5" />
      <rect x="13" y="13" width="6" height="6" rx="1.5" />
    </svg>
  );
}

function CompareIcon({ className = "" }: IconProps) {
  return (
    <svg aria-hidden="true" className={className} fill="none" viewBox="0 0 24 24">
      <path d="M7 6h10" />
      <path d="M7 18h10" />
      <path d="M9 4v16" />
      <path d="M15 4v16" />
      <path d="M5 10l2-4 2 4" />
      <path d="M15 14l2 4 2-4" />
    </svg>
  );
}

function CartIcon({ className = "" }: IconProps) {
  return (
    <svg aria-hidden="true" className={className} fill="none" viewBox="0 0 24 24">
      <path d="M3.5 5h2.1l2.1 10.2a2 2 0 0 0 2 1.6h7.5a2 2 0 0 0 1.9-1.4l1.5-5.6H7" />
      <circle cx="10" cy="20" r="1.4" />
      <circle cx="18" cy="20" r="1.4" />
    </svg>
  );
}

function Badge({ value }: { value: number }) {
  if (value <= 0) {
    return null;
  }

  return <span className="mobile-nav-badge">{formatNumber(value)}</span>;
}

function MobileBottomNav({
  cartItemsCount,
  compareItemsCount,
  onCartClick,
  onCompareClick,
  onHomeClick,
  onProductsClick,
  onSearchClick,
  onStoresClick
}: MobileBottomNavProps) {
  return (
    <nav className="mobile-bottom-nav" aria-label="Navegación mobile">
      <button onClick={onHomeClick} type="button">
        <HomeIcon className="mobile-nav-icon" />
        <span>Inicio</span>
      </button>
      <button onClick={onSearchClick} type="button">
        <SearchIcon className="mobile-nav-icon" />
        <span>Buscar</span>
      </button>
      <button onClick={onStoresClick} type="button">
        <StoreIcon className="mobile-nav-icon" />
        <span>Tiendas</span>
      </button>
      <button onClick={onProductsClick} type="button">
        <ProductsIcon className="mobile-nav-icon" />
        <span>Productos</span>
      </button>
      <button onClick={onCompareClick} type="button">
        <span className="mobile-nav-icon-wrap">
          <CompareIcon className="mobile-nav-icon" />
          <Badge value={compareItemsCount} />
        </span>
        <span>Comparar</span>
      </button>
      <button onClick={onCartClick} type="button">
        <span className="mobile-nav-icon-wrap">
          <CartIcon className="mobile-nav-icon" />
          <Badge value={cartItemsCount} />
        </span>
        <span>Carrito</span>
      </button>
    </nav>
  );
}

export default MobileBottomNav;
